import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ size = 40, withText = true, className = "" }) => (
  <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    <img src="/pantry-pilot-logo.png" alt="Pantry Pilot" width={size} height={size}
         className="rounded-xl object-cover" style={{ width: size, height: size }} />
    {withText && (
      <span className="font-extrabold tracking-tight text-pp-text leading-none" style={{ fontSize: size * 0.5 }}>
        Pantry<span className="text-pp-forest">Pilot</span>
      </span>
    )}
  </Link>
);
